import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { chatService } from '@/lib/api/services/chat.service';

export function useUserPreferences() {
  const queryClient = useQueryClient();

  const { data: preferences, isLoading } = useQuery({
    queryKey: ['user-preferences'],
    queryFn: () => chatService.getUserPreferences(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  const updateMutation = useMutation({
    mutationFn: (updates: { tips_enabled?: boolean; helper_collapsed?: boolean; suggestions_collapsed?: boolean }) =>
      chatService.updateUserPreferences(updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user-preferences'] });
    },
  });

  return {
    preferences: preferences || {
      tips_enabled: true,
      helper_collapsed: true,
      suggestions_collapsed: true,
    },
    isLoading,
    updatePreferences: updateMutation.mutateAsync,
    isUpdating: updateMutation.isPending,
  };
}

